import { CSSProperties, ReactNode } from "react";

export const FormLayoutContainer = ({ style, children }: { style?: CSSProperties; children: ReactNode }) => (
  <div className="default-form-container col-md-12 col-xs-12" style={style}>
    {children}
  </div>
);
